import { Box, Tabs, Tab } from '@mui/material'
import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation, Outlet } from 'react-router-dom'
import { Instagram, Youtube, Facebook } from 'lucide-react'

export default function Automations(): JSX.Element {
  const navigate = useNavigate()
  const location = useLocation()
  
  // Determine active tab based on current route
  const getCurrentTab = () => {
    if (location.pathname.includes('youtube')) return 1
    if (location.pathname.includes('facebook')) return 2
    return 0 // Default to Instagram
  }
  
  const [activeTab, setActiveTab] = useState(getCurrentTab())
  
  useEffect(() => {
    setActiveTab(getCurrentTab())
  }, [location.pathname])

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue)
    switch (newValue) {
      case 0:
        navigate('/automations/instagram')
        break
      case 1:
        navigate('/automations/youtube')
        break
      case 2:
        navigate('/automations/facebook')
        break
    }
  }

  return (
    <Box sx={{ minHeight: '100vh', paddingTop: '24px' }}>
      {/* Platform Tabs */}
      <Box
        sx={{
          marginBottom: '32px',
          padding: '0 24px',
        }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          sx={{
            background: 'rgba(30, 41, 59, 0.4)',
            backdropFilter: 'blur(12px)',
            borderRadius: '16px',
            border: '1px solid rgba(168, 85, 247, 0.2)',
            padding: '8px',
            minHeight: '56px',
            '& .MuiTabs-indicator': {
              display: 'none',
            },
          }}
        >
          <Tab
            icon={<Instagram size={20} />}
            iconPosition="start"
            label="Instagram"
            sx={{
              minHeight: '48px',
              borderRadius: '12px',
              color: 'rgba(255, 255, 255, 0.6)',
              fontWeight: 600,
              textTransform: 'none',
              transition: 'all 0.3s ease',
              '&.Mui-selected': {
                color: '#ffffff',
                background: 'linear-gradient(135deg, #a855f7, #ec4899)',
                boxShadow: '0 4px 12px rgba(168, 85, 247, 0.4)',
              },
              '&:hover': {
                color: '#ffffff',
                background: activeTab === 0 
                  ? 'linear-gradient(135deg, #a855f7, #ec4899)'
                  : 'rgba(168, 85, 247, 0.1)',
              },
            }}
          />
          <Tab
            icon={<Youtube size={20} />}
            iconPosition="start"
            label="YouTube"
            sx={{
              minHeight: '48px',
              borderRadius: '12px',
              color: 'rgba(255, 255, 255, 0.6)',
              fontWeight: 600,
              textTransform: 'none',
              transition: 'all 0.3s ease',
              '&.Mui-selected': {
                color: '#ffffff',
                background: 'linear-gradient(135deg, #ff0000, #cc0000)',
                boxShadow: '0 4px 12px rgba(255, 0, 0, 0.4)',
              },
              '&:hover': {
                color: '#ffffff',
                background: activeTab === 1 
                  ? 'linear-gradient(135deg, #ff0000, #cc0000)'
                  : 'rgba(255, 0, 0, 0.1)',
              },
            }}
          />
          <Tab
            icon={<Facebook size={20} />}
            iconPosition="start"
            label="Facebook"
            disabled
            sx={{
              minHeight: '48px',
              borderRadius: '12px',
              color: 'rgba(255, 255, 255, 0.3)',
              fontWeight: 600,
              textTransform: 'none',
              opacity: 0.5,
            }}
          />
        </Tabs>
      </Box>

      {/* Content Area - Shows child route */}
      <Outlet />
    </Box>
  )
}